import { supabase } from "@/infrastructure/supabase/client";
import type {
  CoverageFilter,
  CriterionDerivationKind,
  CriterionGroup,
  EvaluationCriterionRow,
} from "@/infrastructure/supabase/database.types";

export interface UpsertCriterionInput {
  id?: string;
  slug: string;
  name: string;
  description: string | null;
  rubric: string | null;
  weight_default: number;
  is_dealbreaker_eligible: boolean;
  display_order: number;
  derivation_kind: CriterionDerivationKind;
  coverage_filter: CoverageFilter | null;
  group_key: CriterionGroup;
}

export const evaluationCriteriaRepository = {
  async list(): Promise<EvaluationCriterionRow[]> {
    const { data, error } = await supabase
      .from("evaluation_criteria")
      .select("*")
      .order("display_order", { ascending: true });
    if (error) throw error;
    return data ?? [];
  },

  async upsert(input: UpsertCriterionInput): Promise<EvaluationCriterionRow> {
    const { data, error } = await supabase
      .from("evaluation_criteria")
      .upsert(input, { onConflict: "slug" })
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase.from("evaluation_criteria").delete().eq("id", id);
    if (error) throw error;
  },
};
